import { useUserColumns } from '@services/auth'
import { pathOr, pluck } from 'ramda'
import ConnectorStatusLabel from 'src/components/ConnectorStatusLabel'
import styled, { css } from 'styled-components'
import { useDashboardContext } from '../../Provider'

const ChargingPointRow = (props: { chargingPoints?: any }) => {
  const { chargingPoints = [] } = props

  const { setSelectedChargingPoint, selectedChargingPoint } =
    useDashboardContext()

  const { userColumns } = useUserColumns()

  return (
    <div>
      {chargingPoints.map((chargingPoint: any) => {
        const connectors = pathOr([], ['connectors'], chargingPoint)
        return (
          <Row
            key={chargingPoint.id}
            actived={
              selectedChargingPoint?.chargingPoint?.id === chargingPoint.id
            }
            onClick={() =>
              setSelectedChargingPoint({
                chargingPoint,
                sideMenuMode: 'secondary',
              })
            }>
            <div className="flex text-sm align-center p-2">
              <label>
                充電樁（
                {pathOr('', ['properties', 'chargingPointType'], chargingPoint)}
                ）
              </label>
              {connectors.map((connector: any) => (
                <ConnectorStatusLabelStyled
                  key={connector.connectorId}
                  status={connector.status}
                  statusStr={connector.statusStr}
                  type="text"
                />
              ))}
            </div>
            <div className="flex text-sm align-center p-2 ">
              <DeviceIdLabel>
                {pluck('deviceId', connectors).join(' / ')}
              </DeviceIdLabel>
            </div>
          </Row>
        )
      })}
    </div>
  )
}

export default ChargingPointRow

const Row = styled.div<{ actived?: boolean }>`
  display: flex;
  flex-direction: column;
  background-color: #1b1d1d;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-left-width: 0;
  border-right-width: 0;
  min-height: 50px;
  padding: 8px;
  margin: 0 -10px;
  cursor: pointer;
  ${p =>
    p.actived &&
    css`
      background-color: rgba(32, 228, 255, 0.2);
      border: 2px solid #20e4ff;
      border-left-width: 2;
      border-right-width: 2;
    `}
`
const ConnectorStatusLabelStyled = styled(ConnectorStatusLabel)`
  display: inline-flex;
  &:nth-child(3) {
    &:before {
      content: '';
      display: inline-block;
      width: 2px;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.5);
      margin: 0px 5px;
    }
  }
`

const DeviceIdLabel = styled.label`
  color: rgba(255, 255, 255, 0.5);
`
